import { FC, useState } from 'react'
import { useParams } from 'react-router-dom'

import CONFIG from '../../../../config'
import { utils } from '../../../utils'
import { FormResponseStatus, AuthUserStatus } from '../../../models'
import { Layout } from '../../../containers'
import { Title, Text, Card, Loading, LinkBack } from '../../../components/UI'
import { Modal, useModal } from '../../../components/UI/Modal'
import { AdminUserForm, AdminUserFormSuccess, RegisterFormError } from '../../../components'
import { useUser } from '../../../hooks'

const AdminUserEditPage:FC = ()  => {
  const { id } = useParams<{ id: string }>()
  const [respUserStatus, setRespUserStatus] = useState<AuthUserStatus>('')
  const modal = useModal()
  const { user, getUserStatusId } = useUser(Number(id))

  const getFormType = () => {
    return (getUserStatusId() === 3 ? 'VALIDATE' : 'EDIT')
  }

  const getMessage = () => {
    if(getFormType() === 'VALIDATE') return 'El usuario registrado recibirá un correo electrónico de confirmación'
    else return 'El usuario ha sido actualizado exitosamente'
  }

  const getTitle = () => {
    const formType = getFormType()

    if(formType === 'EDIT') return '¡Usuario actualizado!'
    else if(formType === 'VALIDATE') {
      if(respUserStatus === 'ENABLED') return '¡Usuario validado!'
      else return '¡Usuario denegado!'
    } else {
      return undefined
    }
  }

  const onFormSubmitChange = (respStatus: FormResponseStatus, userStatus: AuthUserStatus, message: string = '') => {
    modal.setStatus(respStatus)
    modal.setMessage(message)
    setRespUserStatus(userStatus)
    modal.open()
  }

  return (
    <Layout role="ADMIN_ROLE">
      <div className="container register-wrapper pt-50 pb-70">
      <div className="d-flex justify-content-between">
          <Title border>{getFormType() === 'VALIDATE' ? 'Validar' : 'Actualizar'} usuario</Title>

          <LinkBack link={CONFIG.ROUTES.ADMIN.USERS.HOME} />
        </div>

        <Text size="14" lineHeight="6" className="lg:fz-16 mt-40">
          {getFormType() === 'VALIDATE' ?
              <>Valida los datos del paciente de acuerdo a los datos registrados en Mi Portal INDISA.</>
            :
              <>Ingresa los datos que deseas actualizar en Mi Portal INDISA.</>
          }
        </Text>

        <Card showOnly="lg" className="lg:py-70 lg:px-70 mt-50 lg:mt-25">
          {!utils.isObjectEmpty(user) ?
              <AdminUserForm type={getFormType()} user={user} onSubmitChange={(respStatus, userStatus, message) => onFormSubmitChange(respStatus, userStatus, message)} />
            :
              <div className="text-center">
                <Loading />
              </div>
          }
        </Card>
      </div>

      <Modal show={modal.show} maxWidth="490px" onClose={() => modal.close()}>
        {modal.status === 'SUCCESS' &&
          <AdminUserFormSuccess
            type={getFormType()}
            title={getTitle()}
            wrapper
            onClick={() => modal.close()}>
              {getMessage()}
            </AdminUserFormSuccess>
        }
        {modal.status === 'ERROR' && <RegisterFormError message={modal.message} onClick={() => modal.close()}/>}
      </Modal>
    </Layout>
  )
}

export { AdminUserEditPage }